import React from 'react';
import {
  Col,
  Input,
  InputNumber,
  Modal,
  Row,
  Space,
  Switch,
} from 'antd';
import { FormLabel } from 'components/common';

type Props = {
  onClose?: Function;
  visible: boolean;
  shipHandler: Function;
};

const ShippingLabelPrintedFromChannelDialog = (props: Props) => {
  const { useState } = React;
  const [trackingNumber, setTrackingNumber] = useState('');
  const [secondaryTrackingNumber, setSecondaryTrackingNumber] = useState('');
  const [shippingFee, setShippingFee] = useState<number>();
  const [syncToChannel, setSyncToChannel] = useState(false);
  const [visible, setVisible ] = useState(props.visible);

  const handleShipping = () => {
    const sd = {
      secondaryTrackingNumber,
      shippingFee,
      syncToChannel,
      trackingNumber,
    };

    props.shipHandler(sd);
    onClose();
  };

  const onClose = () => {
    setVisible(false);

    if (props.onClose) props.onClose();
  };

  const onSecondaryTrackingNumberChange = (evt: any) => {
    setSecondaryTrackingNumber(evt.target.value);
  };

  const onShippingFeeChange = (fee: any) => {
    if (typeof fee === 'number') {
      setShippingFee(fee);
    }
  };

  const onSyncToChannelChange = (checked: any) => {
    setSyncToChannel(checked);
  };

  const onTrackingNumberChange = (evt: any) => {
    setTrackingNumber(evt.target.value);
  };

  return (<>
    <Modal
      centered
      destroyOnClose
      onCancel={onClose}
      onOk={handleShipping}
      title="Shipping Label Printed From Channel"
      visible={visible}
      width={640}
    >
      <Space
        direction="vertical"
        size={16}
        style={{width: '100%'}}
      >
        <Row align="middle">
          <Col span={8}>
            <FormLabel>Tracking Number</FormLabel>
          </Col>
          <Col span={16}>
            <Input
              onChange={onTrackingNumberChange}
              value={trackingNumber}
            />
          </Col>
        </Row>
        <Row align="middle">
          <Col span={8}>
            <FormLabel>Secondary Tracking Number</FormLabel>
          </Col>
          <Col span={16}>
            <Input
              onChange={onSecondaryTrackingNumberChange}
              value={secondaryTrackingNumber}
            />
          </Col>
        </Row>
        <Row align="middle">
          <Col span={8}>
            <FormLabel>Shipping Fee</FormLabel>
          </Col>
          <Col span={16}>
            <InputNumber
              min={0}
              onChange={onShippingFeeChange}
              style={{width: '100%'}}
              value={shippingFee}
            />
          </Col>
        </Row>
        <Row align="middle">
          <Col span={8}>
            <FormLabel>Sync To Channel</FormLabel>
          </Col>
          <Col span={16}>
            <Switch
              checked={syncToChannel}
              checkedChildren="Yes"
              onChange={onSyncToChannelChange}
              unCheckedChildren="No"
            />
          </Col>
        </Row>
      </Space>
    </Modal>
  </>);
};

export default ShippingLabelPrintedFromChannelDialog;
